var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('span',{staticClass:"iconfont icon-houzhenzhongqz18"}),_c('span',{staticClass:"ml10"},[_vm._v(_vm._s(_vm.showText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }